module.exports = __webpack_public_path__ + "static/img/story02.53729af.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/index/story/story02.jpg
// module id = Avd3
// module chunks = 1